// extracted by mini-css-extract-plugin
export default {"page":"di-z","cartModal":"ei-z","checkout":"fi-z","placeholder":"gi-z","account":"hi-z"};